<template>
  <b-overlay
    :show="__isOnLoad"
    variant="white"
    rounded
    opacity="0.70"
    spinner-variant="primary"
    spinner-small
    style="float: left; width: 100%"
  >

  

  <b-modal 
    v-if="showDevis !== null"
    v-model="showPopup"
          centered
          modal-class="app-popup-shell"
          dialog-class="app-popup-dialog"
          content-class="app-popup-content"
          body-class="app-popup-body"
          :hide-footer= "true"
          size="xl"
          title="" header-class="app-popup-header"
          >
          <Template :__object="showDevis"></Template>
  </b-modal>
  <div class="row pageHeader" v-if="!isLightMode">
  <div class="row subMenu">
    <b-button size="sm" variant="danger" style="float: right; margin: 5px" :class="{ activeFilterButton: showFilter }" @click.stop="toggleFilterPanel()">Filtrer</b-button>
  </div>

    <FilterDrawerShell
      :show="showFilter"
      title="Filtres avoirs"
      :count="filtredListitems.length"
      @close="closeFilterPanel"
    >
      <template #sorts>
        <div class="sortItem">
          <b-icon :class="getIsActifSort(sortFiltre.isDate.state)" icon="check-square-fill" @click="sortFiltre.isDate.state = !sortFiltre.isDate.state"></b-icon>
          <span>Date</span>
          <b-icon class="redColor" v-if="sortFiltre.isDate.state" icon="recycle" @click="sortFiltre.isDate.isUp = !sortFiltre.isDate.isUp"></b-icon>
        </div>
        <div class="sortItem">
          <b-icon :class="getIsActifSort(sortFiltre.isName.state)" icon="check-square-fill" @click="sortFiltre.isName.state = !sortFiltre.isName.state"></b-icon>
          <span>Nom</span>
          <b-icon class="redColor" v-if="sortFiltre.isName.state" icon="recycle" @click="sortFiltre.isName.isUp = !sortFiltre.isName.isUp"></b-icon>
        </div>
        <div class="sortItem">
          <b-icon :class="getIsActifSort(sortFiltre.isActivated.state)" icon="check-square-fill" @click="sortFiltre.isActivated.state = !sortFiltre.isActivated.state"></b-icon>
          <span>Etat</span>
          <b-icon class="redColor" v-if="sortFiltre.isActivated.state" icon="recycle" @click="sortFiltre.isActivated.isUp = !sortFiltre.isActivated.isUp"></b-icon>
        </div>
      </template>

      <div class="filterField">
        <label>Société</label>
        <base-input
          placeholder="Société"
          v-model="filterContainer.keySearchSte"
          type="string"
        >
        </base-input>
      </div>
    </FilterDrawerShell>
  </div>

    <div :class="getMainPanel">

      <div
        :class="styleSublisteMode"
        v-for="(item, index) in filtredListitems"
        :key="index"
        :style="getState(item.status)"
        v-if="isLightMode"
      >
        <div class="recordLightCard">
          <div class="recordLightIdentity">
            <div class="recordLightRef">{{ item.type }} N° {{item.num}} / {{item.exercice}}</div>
            <div class="recordLightMeta">{{ item.owner && item.owner.name ? item.owner.name : 'Client' }}</div>
          </div>
          <div class="recordLightAmount">
            <span>TTC</span>
            <b>{{ formatMoney(item.totalTTC) }}</b>
          </div>
          <div class="recordLightActions">
            <b-button size="sm" variant="danger" @click="setReject(item)" v-if="['NOUVEAU'].includes(item.status) && isAllow()">Annuler</b-button>
            <b-button size="sm" variant="primary" @click="setValide(item)" v-if="item.status === 'NOUVEAU' && isAllow()">Valider</b-button>
            <b-button size="sm" variant="info" @click="showDevis = item;showPopup=true ">Voir</b-button>
          </div>
        </div>
      </div>


      <div
        :class="styleSublisteMode"
        v-for="(item, index) in filtredListitems"
        :key="index"
        :style="getState(item.status)"
        v-if="!isLightMode"
      >
        <div class="recordCard">
          <div class="recordCardTop">
            <div class="recordCardIdentity">
              <div class="recordCardNumber">N° {{item.num}} / {{item.exercice}}</div>
              <div class="recordCardType">{{ item.type }}</div>
            </div>

            <div class="recordCardClient">
              <div class="recordCardDate">{{ __._getDate(item.createdAt) }}</div>
              <div class="recordCardOwner">{{ item.owner && item.owner.name ? item.owner.name : 'Client non renseigné' }}</div>
            </div>

            <div class="recordCardAmount">
              <span class="recordCardAmountLabel">Montant TTC</span>
              <b class="recordCardAmountValue">{{ formatMoney(item.totalTTC) }}</b>
            </div>
          </div>

          <div class="recordCardBody">
            <div class="recordInfoBlock">
              <div class="recordInfoLabel">Lignes de l'avoir</div>
              <div class="recordArticlesList" v-if="item.devis && item.devis.length">
                <div v-for="(article, idx) in item.devis" :key="idx" class="recordArticleRow">
                  <span class="recordArticleQty">{{ article.qte }}</span>
                  <span class="recordArticleRef">{{ article.ref }}</span>
                  <span class="recordArticleName">{{ article.name }}</span>
                </div>
              </div>
              <div class="recordEmptyText" v-else>Aucune ligne d'avoir.</div>
            </div>
          </div>

          <div class="recordCardBottom">
            <div class="recordNotif" v-if="item.notif">{{item.notif}}</div>
            <div class="recordActions">
              <b-button size="sm" variant="danger" @click="setReject(item)" v-if="['NOUVEAU'].includes(item.status) && isAllow()">Annuler l'avoir</b-button>
              <b-button size="sm" variant="success" @click="showDevis = item;showPopup=true ">Voir l'avoir</b-button>
              <b-button size="sm" variant="primary" @click="setValide(item)" v-if="item.status === 'NOUVEAU' && isAllow()">Valider l'avoir</b-button>
              <ico-btn
                v-if="canDeleteItem(item)"
                size="p"
                type="warning"
                icone="trash"
                title="Supprimer"
                :cb="
                  () => {
                    dispatchDelete(item._id);
                  }
                "
              ></ico-btn>
            </div>
          </div>
        </div>
      </div>
    </div>
  </b-overlay>
</template>
<script>
import Vue from "vue";
import Template from "@/pages/commun/Template";
import FilterDrawerShell from "@/components/FilterDrawerShell.vue";
export default {
  components: {
    Template,
    FilterDrawerShell
  },
  props: {
    isLightMode: {
      type: Boolean,
      default: () => {
        return false;
      },
    },
    __isOnLoad: {
      type: Boolean,
      default: () => {
        return false;
      },
    },
    __list: {
      type: Array,
      default: () => {
        return [];
      },
    },

  },

  data() {
    return {
      filterContainer: { keySearchSte: "" },
      structure: {},
      showPopup:null,
      showFilter: false,
      onGoingReq:[],
      admin: null,
      filtredListitems: [],
      showDevis: null,
      sortFiltre: {
        isDate: {state: false, isUp: true },
        isName:  {state: false, isUp: true },
        isActivated:  {state: false, isUp: true },
      }
    };
  },
  methods: {
    normalizeNum(value) {
      const parsed = Number(value);
      return Number.isFinite(parsed) ? parsed : 0;
    },

    getLastDocumentId() {
      if (!Array.isArray(this.__list) || this.__list.length === 0) {
        return null;
      }

      const latestDocument = this.__list.reduce((selected, document) => {
        if (!document) {
          return selected;
        }

        if (!selected) {
          return document;
        }

        const currentNum = this.normalizeNum(document.num);
        const selectedNum = this.normalizeNum(selected.num);

        if (currentNum > selectedNum) {
          return document;
        }

        if (currentNum < selectedNum) {
          return selected;
        }

        const currentDate = new Date(document.createdAt || 0).getTime();
        const selectedDate = new Date(selected.createdAt || 0).getTime();

        return currentDate >= selectedDate ? document : selected;
      }, null);

      return latestDocument ? latestDocument._id : null;
    },

    isLastDocument(item) {
      return Boolean(item && item._id && item._id === this.getLastDocumentId());
    },

    canDeleteItem(item) {
      return !this.isLightMode && this.isAllow() && this.isLastDocument(item);
    },

    toggleFilterPanel() {
      this.showFilter = !this.showFilter;
    },

    closeFilterPanel() {
      this.showFilter = false;
    },

    dispatchDelete(idx) {
      this.$bvModal
        .msgBoxConfirm("Veuillez confirmer la suppression.", {
          title: "Confirmation",
          size: "sm",
          buttonSize: "sm",
          okVariant: "danger",
          okTitle: "Confirmer",
          cancelTitle: "Annuler",
          footerClass: "p-2",
          hideHeaderClose: true,
          centered: false,
        })
        .then((value) => {
          if (value) {
            this.$parent.deleteAction(idx);
          }
        });
    },

    isAllow() {
      if(this.admin && ['ROOT','ADMIN', 'COMMERCIAL'].includes(this.admin.type)) {
        return true
      } 
      return false
    },

    filtredList() {
      var ret = Array.isArray(this.__list) ? [...this.__list] : [];

      if (this.filterContainer.keySearchSte)
        ret = ret.filter((e) =>
        e.owner && e.owner.name && e.owner.name.includes(this.filterContainer.keySearchSte) 
        );

    
        if(this.sortFiltre.isDate.state === true) {
        if(this.sortFiltre.isDate.isUp)
          ret = ret.sort((a, b) => (new Date(a.createdAt)).getTime() - (new Date(b.createdAt)).getTime());
        else
        ret = ret.sort((a, b) => (new Date(b.createdAt)).getTime() - (new Date(a.createdAt)).getTime());
      }

        
      if(this.sortFiltre.isName.state === true) {
        if(this.sortFiltre.isName.isUp)
          ret = ret.sort((a, b) => String((a.owner && a.owner.name) || "").localeCompare(String((b.owner && b.owner.name) || "")));
        else
          ret = ret.sort((a, b) => String((b.owner && b.owner.name) || "").localeCompare(String((a.owner && a.owner.name) || "")));
      }



      if(this.sortFiltre.isActivated.state === true) {
        
        if(this.sortFiltre.isActivated.isUp)
          ret = ret.sort((a, b) => String(a.status).localeCompare(String(b.status)));
        else
          ret = ret.sort((a, b) => String(b.status).localeCompare(String(a.status)));
      }
      
      this.filtredListitems = ret.filter(e => e.name !== '');
      //return ret;
    },
    

    setReject(item) {
      this.$bvModal
        .msgBoxConfirm("Rejeter l'avoir'?", {
          title: "Confirmation",
          size: "sm",
          buttonSize: "sm",
          okVariant: "danger",
          okTitle: "Confirmer",
          cancelTitle: "Annuler",
          footerClass: "p-2",
          hideHeaderClose: true,
          centered: false,
        })
        .then((value) => {
          if (value) {
            this.$parent.setUpdateValue(item._id, 'REJETE', 'status');
            this.$parent.setUpdateValue(item._id, 'Avoir annulé par '+this.admin.name+' le '+this.__._getDate(null), 'notif');
          }
        });
    },


    setValide(item) {
      this.$bvModal
      .msgBoxConfirm("Avoir validé ? Une fois validé, l'avoir sera visible sur le compte client.", {
          title: "Confirmation",
          size: "sm",
          buttonSize: "sm",
          okVariant: "danger",
          okTitle: "Confirmer",
          cancelTitle: "Annuler",
          footerClass: "p-2",
          hideHeaderClose: true,
          centered: false,
        })
        .then((value) => {
          if (value) {
            this.$parent.setUpdateValue(item._id, 'VALIDE', 'status');
            this.$parent.setUpdateValue(item._id, 'Avoir validé par '+this.admin.name+' le '+this.__._getDate(null), 'notif');
          }
        });
    },


    getIsActif(isActif) {
      return isActif === true
        ? ""
        : "redColor";
    },

    getIsActifSort(isActif) {
      return isActif === false
        ? "grayColor"
        : "greenColor";
    },

    formatMoney(value) {
      const amount = Number(value || 0);
      if (!Number.isFinite(amount)) {
        return value;
      }

      return amount.toLocaleString("fr-FR", {
        minimumFractionDigits: 0,
        maximumFractionDigits: 3,
      });
    },

    getState(state) {
      switch (state) {
        case 'NOUVEAU':
          return 'border-left: solid 10px #CCC;'
          break;

        case 'VALIDE':
          return 'border-left: solid 10px green;'
          break;
        case 'REJETE':
          return 'border-left: solid 10px red'
          break;
        default:
          break;
      }
    },
  },
  watch: {
    __isOnLoad: function () {},
  },
  computed: {
    styleSublisteMode() {
      return (this.$props.isLightMode) ? "lightMode col-md-12" : "listeMode col-md-12";
    },

   

    getMainPanel() {
      return (this.isLightMode) ? "row mainPanelnoFilter" : "row mainPanelWithoutFilter";
    },

    
  },

  mounted() {
    setTimeout(()=>this.filtredList(),400);
    this.admin = Vue.$cookies.get("user");
  },

  watch: {
    __isOnLoad: {
      deep: true,
      handler(newValue, oldValue) {
        console.log("newValueList")
        this.filtredList()
      },
    },

    __list: {
      deep: true,
      handler() {
        this.filtredList();
      },
    },
   
    filterContainer: {
      deep: true,
      handler(newValue, oldValue) {
        console.log("newValue")
        this.filtredList()
      },
    },

    sortFiltre: {
      deep: true,
      handler(newValue, oldValue) {
        console.log("newValue")
        this.filtredList()
      },
    },
  },
};
</script>
<style scoped>
.redColor {
  color: red
}
.greenColor {
  color: green;
}
.grayColor {
  color: #CCC;
}
.listeMode {
  padding: 1%;
  margin-bottom: 10px;
  border-radius: 10px;
  min-height: 40px;
  background-color: #fff;
}

.lightMode {
  padding: 1%;
  margin-bottom: 12px;
  border-radius: 10px;
  background-color: #F2F2F2;
}

.listeMode .menu {
  float: right;
  border-radius: 10px;
  background-color: #fff;
}
.pic {
  width: 17%;
  margin-right: 3%;
  float: left;
}
.pic img {
  border-radius: 50%;
}
.preview {
  float: left;
  font-weight: bolder;
}

.preview em {
  font-weight: lighter;
  font-size: 12px;
}

.flowted {
  filter: blur(3.5px);
}

.actif {
  filter: none;
  background-color: #131016;
}
.mainPanelWithoutFilter {
  margin-top: 100px;
}

.mainPanelnoFilter {
  margin-top: 0px;
}

.subMenu {
    width: 100%;
    padding-left: 10%;
    padding-right: 10%;
    background-color: black;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 4px;
    min-height: 40px;
    padding-top: 5px;
    padding-bottom: 5px;
  }
  .pageHeader {
    position: fixed;
    top: 120px;
    left: 0;
    width: 100%;
    z-index:333;
    background: #f2f2f2;
    overflow: visible;
  }
  .pageHeader.row,
  .subMenu.row {
    margin-left: 0;
    margin-right: 0;
  }
  .serachPanel {
    position: fixed;
  top: 119px;
    right: 0;
    width: min(420px, calc(100vw - 36px));
    height: calc(100vh - 148px);
    overflow-x: hidden;
    overflow-y: auto;
    padding: 20px;
    background: linear-gradient(180deg, #ffffff 0%, #f8fafc 100%);
  border-radius: 0;
    box-shadow: 0 22px 55px rgba(15, 23, 42, 0.2);
    border: 1px solid #dbe4f0;
    z-index: 334;
    font-size: 14px;
    animation: filterPanelReveal 0.24s ease;
  }
  .serachPanel.row {
    margin-left: 0;
    margin-right: 0;
  }
  .serachPanel [class*="col-"] {
    flex: 0 0 100%;
    max-width: 100%;
    padding: 0 0 10px;
  }
  .filterPanelHeader {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: 12px;
    padding-bottom: 14px;
    margin-bottom: 14px;
    border-bottom: 1px solid #e2e8f0;
  }
  .filterPanelTitle {
    font-size: 21px;
    font-weight: 700;
    color: #0f172a;
  }
  .filterPanelCount {
    font-size: 14px;
    color: #64748b;
    margin-top: 4px;
  }
  .filterCloseBtn {
    background: #1f2a44;
    color: #fff;
    border: none;
    border-radius: 10px;
    font-size: 13px;
    padding: 7px 14px;
  }
  .filterQuickTools {
    padding: 14px !important;
    background: linear-gradient(180deg, #f8fafc 0%, #f1f5f9 100%);
    border: 1px solid #e2e8f0;
  border-radius: 0;
    margin-bottom: 8px;
  }
  .filterQuickTitle {
    font-size: 12px;
    font-weight: 700;
    text-transform: uppercase;
    color: #475569;
    margin-bottom: 10px;
    letter-spacing: 0.04em;
  }
  .serachPanel .form-control,
  .serachPanel .custom-select {
    width: 100%;
    min-height: 46px;
    font-size: 15px !important;
    border-radius: 12px;
  }
  .serachPanel [class*="col-"] {
    font-size: 15px;
  }

@keyframes filterPanelReveal {
  from {
    opacity: 0;
    transform: translateX(24px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
}

@media (max-width: 768px) {
  .pageHeader {
    top: 50px;
  }

  .subMenu {
    padding: 6px 10px;
    justify-content: center;
  }

  .serachPanel {
    top: 119px;
    right: 0;
    width: calc(100vw - 20px);
    height: calc(100vh - 108px);
    padding: 12px;
  }

  .mainPanelWithoutFilter {
    margin-top: 110px;
  }
}
</style>

